import { Alert, AlertTitle, Box, Button, Dialog, DialogContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Archive } from "@phosphor-icons/react";
import React from "react";
import useDisableClientInsurance from "hooks/api/client/useDisableClientInsurance";
import { useDispatch } from "react-redux";
import actions from "actions";

interface InsuranceAsInactiveDialogProps {
  open: boolean;
  onClose: () => void;
  insurance: any;
  clientId: string;
}

export const InsuranceAsInactiveDialog: React.FC<InsuranceAsInactiveDialogProps> = ({
  open,
  onClose,
  insurance,
  clientId,
}) => {
  const { disableInsuranceMutation, isMutationDisableInsuranceLoading: isLoading } =
    useDisableClientInsurance();
  const dispatch = useDispatch();

  const handleConfirmSetAsInactive = () => {
    if (insurance) {
      disableInsuranceMutation(
        { id: insurance.id },
        {
          onSuccess: () => {
            dispatch(actions.getUserInsurance(parseInt(clientId)));
            onClose();
          },
          onError: (error) => {
            console.error("Error inactivating insurance:", error);
          },
        }
      );
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={handleCancel}
      aria-labelledby="insurance-inactive-title"
    >
      <DialogContent sx={{ zIndex: 2010 }}>
        <Alert severity="error" sx={{ marginBottom: "24px" }}>
          <AlertTitle>Set insurance coverage as inactive?</AlertTitle>
          Setting coverage as inactive is permanent. Inactive insurance can be viewed under Past
          Coverage.
        </Alert>

        <Box width="100%" display="flex" flexDirection="row" justifyContent="flex-end">
          <Button
            onClick={handleCancel}
            style={{ marginRight: "8px" }}
            variant="contained"
            color="secondary"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            color="error"
            startIcon={<Archive size={16} />}
            onClick={handleConfirmSetAsInactive}
            loading={isLoading}
          >
            Set as inactive
          </LoadingButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
